// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var userRouter = {
  path: '/user',
  component: Layout,
  redirect: '/user/index',
  name: 'User',
  meta: {
    title: '用户',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/user/list/index');
    },
    name: 'UserIndex',
    meta: {
      title: '用户列表',
      icon: ''
    }
  }, {
    path: 'level',
    component: function component() {
      return import('@/views/user/level');
    },
    name: 'Level',
    meta: {
      title: '用户等级',
      icon: ''
    },
    children: [{
      path: 'list',
      name: 'levelList',
      meta: {
        title: '等级列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/level/list');
      }
    }, {
      path: 'config',
      name: 'levelConfig',
      meta: {
        title: '等级配置',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/level/levelConfig');
      }
    }, {
      path: 'description',
      name: 'levelDescription',
      meta: {
        title: '等级说明',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/level/description');
      }
    }]
  }, {
    path: 'label',
    component: function component() {
      return import('@/views/user/label/index');
    },
    name: 'Label',
    meta: {
      title: '用户标签',
      icon: ''
    }
  }, {
    path: 'paidMembers',
    component: function component() {
      return import('@/views/user/paidMembers');
    },
    name: 'PaidMembers',
    meta: {
      title: '付费会员',
      icon: ''
    },
    children: [{
      path: 'configure',
      name: 'Configure',
      meta: {
        title: '会员配置',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/paidMembers/configure');
      }
    }, {
      path: 'order',
      name: 'MembersOrder',
      meta: {
        title: '购买记录',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/paidMembers/order');
      }
    }]
  }, {
    path: 'partner',
    component: function component() {
      return import('@/views/user/partner');
    },
    redirect: '/user/partner/setting',
    name: 'UserPartner',
    meta: {
      title: '合伙人',
      icon: ''
    },
    children: [{
      path: 'setting',
      name: 'PartnerSetting',
      meta: {
        title: '合伙人设置',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/partner/setting');
      }
    }, {
      path: 'record',
      name: 'PartnerRecord',
      meta: {
        title: '分佣记录',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/partner/record');
      }
    }]
  }, {
    path: 'logout',
    component: function component() {
      return import('@/views/user/logout/index');
    },
    name: 'UserLogout',
    meta: {
      title: '注销申请',
      icon: ''
    }
  }, {
    path: 'balance-record',
    component: function component() {
      return import('@/views/user/balanceRecord/index');
    },
    name: 'UserBalanceRecord',
    meta: {
      title: '余额变更记录',
      icon: ''
    }
  }, {
    path: 'consumer-deduction-record',
    component: function component() {
      return import('@/views/user/consumerDeductionRecord/index');
    },
    name: 'UserConsumerDeductionRecord',
    meta: {
      title: '消费券流水',
      icon: ''
    }
  }]
};
export default userRouter;